import { createClient } from '@supabase/supabase-js'

// Cargo Engage Supabase Configuration
// Replace these with your actual Supabase project credentials
// const supabaseUrl = 'YOUR_SUPABASE_URL' // e.g., 'https://xxxxx.supabase.co'
// const supabaseKey = 'YOUR_SUPABASE_ANON_KEY' // Your anon/public key

const supabaseUrl = 'https://dznggoutqhvcofyrduqp.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR6bmdnb3V0cWh2Y29meXJkdXFwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQwNTI0MTMsImV4cCI6MjA3OTYyODQxM30.bNaYOhuNdnBM5-63ejLUzPsb16WiXlM6Y4LCOKixkg4'

export const supabase = createClient(supabaseUrl, supabaseKey)
